export const FETCH_EVENTS = 'FETCH_EVENTS'

export const LISTEN_CANIDATES = 'LISTEN_CANIDATES'
export const FETCH_MY_EVENTS = 'FETCH_MY_EVENTS'
export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS'
export const FETCH_MYSUBSCRIPTIONS = 'FETCH_MYSUBSCRIPTIONS'
export const SUBSCRIBE_TO_TOPIC = 'SUBSCRIBE_TO_TOPIC'
export const APPLY_NOTIFICATION_TOKEN = 'APPLY_NOTIFICATION_TOKEN'
export const ADD_APPLICATION = 'ADD_APPLICATION'
export const DELETE_APPLICATION = 'DELETE_APPLICATION'
export const FETCH_MYAPPLICATIONS = 'FETCH_MYAPPLICATIONS'
export const FETCH_ADMINCANIDATES = 'FETCH_ADMINCANIDATES'
export const FETCH_REQUESTER = 'FETCH_REQUESTER'
export const LISTEN_ADMIN_EVENTS = 'LISTEN_ADMIN_EVENTS'
export const CURRENT_OPEN_EVENT = 'CURRENT_OPEN_EVENT'
export const TOGGLE_VIEW = 'TOGGLE_VIEW'
export const FETCH_CANIDATES = 'FETCH_CANIDATES'
export const SELECTED_CANIDATE = 'SELECTED_CANIDATE'
export const UPDATE_COUNTER = 'UPDATE_COUNTER'
export const LISTEN_MESSAGING_INBOX = 'LISTEN_MESSAGING_INBOX'
export const MESSAGING_INBOX_COUNTER = 'MESSAGING_INBOX_COUNTER'
export const MESSAGING_FUNCTIONS = 'MESSAGING_FUNCTIONS'
export const PUSH_REQUESTER_DATA = 'PUSH_REQUESTER_DATA'
export const LISTEN_CONFIRMED_EVENTS = 'CONFIRMED_EVENTS'
export const LISTEN_CONNECTED_EVENTS = 'CONNECTED_EVENTS'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js